import { axiosInstance as axios } from "services";

export const fetchRepairPolicy = async () => {
  const { data } = await axios.get("/admin/repairPolicyMaster");
  if (!data.success) throw new Error(data.error || "Failed to fetch repair policy");
  return data;
};
